import { useEffect, useRef, useState } from "react";

export default function useSize() {
  const ref = useRef<HTMLElement>(null);
  const [size, setSize] = useState<{ width: number; height: number }>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const item = ref.current;

    const handleResize = () => {
      if (item) {
        setSize({
          width: item.offsetWidth,
          height: item.offsetHeight,
        });
      }
    };

    handleResize();
    setTimeout(handleResize, 1000);
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { ref, size };
}
